import React, { Component } from 'react';
import { Input } from '@vds/inputs'; 
import {  scrollInView } from '../../../utils/common'; 
import {  Title } from '@vds/typography';
import ExistingCustomer from '../ExistingCustomer/ExistingCustomer';
import { connect } from 'react-redux';
import {
     postUIEventLog
} from '../containers/action';
import {
    savePriceQuoteNumber,saveOptixMonNumber
} from '../../../containers/actions';
import * as SiteAnalytics from '../../../sitecatalyst';
import { Grid, Row, Col } from '@vds/grids';
import { EXISTING_USER_URL } from './../../../containers/APIurls';
import { handleSignInClickEvent, isNightTimeWindow } from './../../../utils/common';
import { isMobile } from 'react-device-detect';
import {TextLink} from '@vds/buttons';
import Icon from '@vds/icons/dist/cjs/Icon';

class RetrieveExistingService extends Component {

    constructor(props) {
        super(props);
       this.state = {
        isNewService: 'Y',
        hasPriceQuote: 'N',
        endInteraction: false,
       };
       props.postUIEventLog({ eventType: 'log', eventName: "EXISTINGORDER_PageLoad", sectionName: "Page" });
       props.history.replace({ pathname: "/ExistingService", state: { prevPage: 'ExS' } })
    }
    componentDidMount() {
            setTimeout(() =>{
                let innerWidth = window.innerWidth
                if(innerWidth < 470){
                    window.scrollTo(0, 0)
                }
            },2000)
        this.setState({ endInteraction: true });
    }

    componentDidUpdate = () => {
        if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            this.setState({ endInteraction: false });
        }
    }
 
    newService = (e) => {
        this.setState({ isNewService: e.target.value });
    } 

    // showPendingOrderPage = () => {
    //     if(this.state.isNewService == 'Y') {
    //         if (this.props?.addressData.addressQualificationDetails?.AddressIdPresent !== "Y" && !isNightTimeWindow()) {
    //             if(window?.newrelic?.addPageAction) {
    //                 window.newrelic.addPageAction('LQAttempts', {data: window.LQRequestBody});
    //                 window.newrelic.addPageAction('LQSuccess', {data: window.LQRequestBody});
    //             }
    //         }
    //         this.props.history.push({ pathname: "/customize-order", search: this.props.history.location.search   });
    //     } else { 
    //         window.location.href = EXISTING_USER_URL;
    //     }
    // }
    showPendingOrderPage = (e, hasQuote) => {
        if (this.state.hasPriceQuote === "Y" || hasQuote) {
            window.sessionStorage.setItem('optixQuoteNum', this.props.addressData?.priceQuoteNumber);
            SiteAnalytics.trackOptixQuoteNumber(this.props.addressData?.priceQuoteNumber);
            SiteAnalytics.trackLQPageSelectedQuoteOption("Review/access existing quote selected");
            this.props.history.push("/optix-checkout");
        }
        else if (this.state.isNewService === 'Y' && this.props.addressData.hasPendingOrder) {
            SiteAnalytics.trackLQPageSelectedQuoteOption("Setup a new service selected");
            SiteAnalytics.trackProductsList(window.LQResponse);
            this.props.history.push("/pendingOrder");
        } else if (this.state.isNewService === 'Y' && !this.props.addressData.hasPendingOrder) {
            if ( !isNightTimeWindow()) {
                SiteAnalytics.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                SiteAnalytics.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                SiteAnalytics.trackLQPageSelectedQuoteOption("Setup a new service selected");
                SiteAnalytics.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                SiteAnalytics.trackProductsList(window.LQResponse);
                if (window?.newrelic?.addPageAction) {
                    window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                }
            }
            this.props.history.push({ pathname: "/customize-order", search:  this.props?.history?.location?.search,  state: { prevPage: 'LQ' } });
        } else {
            // Redirect to login - Need to change
            SiteAnalytics.trackLQPageSelectedQuoteOption("Add or change existing service selected");
            SiteAnalytics.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
            SiteAnalytics.trackProductsList(window.LQResponse);
            window.location.href = EXISTING_USER_URL;
        }
    }

    priceQuote = (value) => {
        this.setState({ hasPriceQuote: value })
    }
    validateAddress = () =>{

    }

    render() {
        
        const {
            addressQualificationDetails,
            optixAddressQualificationDetails, 
        } = this.props.addressData;

        return (
            <div className="retrieveExistingService">
                 <TextLink
          iconPosition="left"
          onClick={() =>{  this.props.history.go(-1);} }
          className="back-es-link mtb1"    
        >
          <span className="arrow-icon">
            <Icon name="caret-left" size="small" />
          </span>
          <span>Back</span>
        </TextLink>
                <Grid>
                    <Row>
                        <Col colSizes={{ "mobile": 4, "tablet": 8, "desktop": 12 }}> 
                       { isMobile ? ( <Title size="large" primitive="h2" bold>
                        
                        This address is in use by a current Verizon customer. 
                
                    </Title> ) : (
                        <Title size="large" primitive="h2" bold>
                        
                            This address is in use by a current<br/> Verizon customer. 
                    
                        </Title>
                    )}
                       
                        </Col>
                    </Row>
                    <Row>
                        <Col colSizes={{ "mobile": 4, "tablet": 8, "desktop": 12 }}> 
                            <ExistingCustomer
                                newService={this.newService}
                                previousHasExistingService={'Y'}
                                showPendingOrderPage={this.showPendingOrderPage}
                                phoneNumber={this.props.phoneNumber}
                                emailAddress={this.props.emailAddress}
                                priceQuoteNumber={this.props.addressData?.priceQuoteNumber}
                                savePriceQuoteNumber={this.props.savePriceQuoteNumber}
                                saveOptixMonNumber={this.props.saveOptixMonNumber}
                                priceQuote={this.priceQuote}
                                validateAddress={this.validateAddress}
                                addressQualificationDetails={addressQualificationDetails}
                                optixAddressQualificationDetails={optixAddressQualificationDetails}
                                postUIEventLog={this.props.postUIEventLog}
                                isExistingServicePage={true}
                            /> 
                        </Col>
                    </Row> 
                 </Grid >
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        addressData: state.AddressValidationPage
    };
};

const mapDispatchToProps = (dispatch) => ({
    
    postUIEventLog: (data) => { dispatch(postUIEventLog(data)) }, 
    savePriceQuoteNumber: (priceQuoteNumber) => {
		dispatch(savePriceQuoteNumber(priceQuoteNumber))
	},
	saveOptixMonNumber: (monNumber) => {
		dispatch(saveOptixMonNumber(monNumber));
	},
});

RetrieveExistingService = connect(mapStateToProps, mapDispatchToProps)(RetrieveExistingService);

export default RetrieveExistingService;